import {
  ADD_FLASH_MESSAGE,
  EMPTY_FLASH_MESSAGE,
  REMOVE_FLASH_MESSAGE
} from "../actions/flashMessage";

const initialState = {
  // messages: [],
  // type: [],
  messages: [
    // {
    //   id: 1,
    //   type: "danger",
    //   title: "Bir Hata Meydana Geldi",
    //   messages: ["Kullanıcı adı alanı boş bırakılamaz"]
    // }
  ]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      if (action.payload.state && action.payload.state.flashMessage) {
        return {
          ...state,
          messages: [action.payload.state.flashMessage]
        };
      } else {
        return {
          ...state,
          messages: []
        };
      }
    case ADD_FLASH_MESSAGE:
      return {
        ...state,
        messages: [
          // ...state.messages,
          {
            type: action.payload.type,
            title: action.payload.title,
            messages: action.payload.messages
          }
        ]
      };
    case EMPTY_FLASH_MESSAGE:
      return {
        ...state,
        messages: []
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/flashMessageReducer.js